export const modalType = {
  TRANSPORT_FORM: 'TRANSPORT_FORM',
  PERMIT_FORM: 'PERMIT_FORM',
  LIMITS_PERMIT_MODAL: 'LIMITS_PERMIT_MODAL',
};
